const InfoLayout = () => import(/* webpackChunkName: "account" */'./layouts/InfoLayout');
const InfoPage = () => import(/* webpackChunkName: "home" */'./containers/InfoPage');
const BlogFullItemPage = () => import(/* webpackChunkName: "account" */'./containers/BlogFullItemPage');

export default {
  path: '',
  component: InfoLayout,
  redirect: { name: 'info' },
  children: [
    {
      path: 'info',
      name: 'info',
      component: InfoPage,
    },
    {
      path: 'info/:slug',
      component: BlogFullItemPage,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/Info/routes.js